<template>
  <v-dialog v-model="dialog" max-width="400">
    <v-card tile flat color="white" v-if="message_notifier_comment != null">
      <v-card-title class="dialog-header-title">Message Email Notifier</v-card-title>

      <v-card-text class="pb-0">
        <v-row dense>
          <v-col>
            <v-row>
              <v-subheader class="font-weight-bold">Recipient</v-subheader>
            </v-row>

            <v-row no-gutters>
              <v-col>
                <v-checkbox
                  v-model="message_notifier_comment.admin_notified"
                  label="Admin"
                ></v-checkbox>
                <v-checkbox
                  v-model="message_notifier_comment.customer_notified"
                  label="Customer"
                ></v-checkbox>
              </v-col>
            </v-row>

            <v-divider></v-divider>
            <v-row>
              <v-subheader class="font-weight-bold">Medium</v-subheader>
            </v-row>

            <v-row no-gutters>
              <v-col>
                <v-checkbox
                  v-model="message_notifier_comment.notify_by_email"
                  label="Email"
                ></v-checkbox>
                <v-checkbox
                  v-model="message_notifier_comment.notify_by_mobile_app"
                  label="Mobile App"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-row justify="end">
          <v-btn
            small
            tile
            depressed
            color="primary"
            class="text-button font-weight-bold mr-2"
            @click="notifyAdminCustomer"
            >NOTIFY</v-btn
          >
          <v-btn
            small
            tile
            depressed
            color="error"
            class="text-button font-weight-bold ml-2"
            @click="onDialogClose"
            >CANCEL</v-btn
          >
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import constant from "@/const";
import "firebase/firestore";

export default {
  props: ["value", "dialog"],

  data() {
    return {
      CONSTANT: constant,
      snackbarColor: "",
      showSnackbar: false,
      snackbarMsg: "",
      snackbarTimeout: 8000,

      collectionComments: "comments",
      collectionMessages: "messages",

      dialogMessageNotifierAdminCustomer: false,
      message_notifier_comment: null,
    };
  },
  created() {},
  mounted() {},
  watch: {
    dialog: function () {
      if (this.dialog) {
        this.message_notifier_comment = this.value;

        // set the default value for the notifier medium to true
        this.message_notifier_comment.notify_by_email = true;
        this.message_notifier_comment.notify_by_mobile_app = true;
      }
    },
  },

  methods: {
    /** Notify admin or customer of message */
    async notifyAdminCustomer() {
      this.$root.blockUImsg = "Notifying...";
      this.$root.blockUIshow = true;

      // console.log("this.message_notifier_comment: ", this.message_notifier_comment);

      let resp = await this.$https.post(
        `/api/admin/message_notifier/${this.message_notifier_comment.company_id}/${this.message_notifier_comment.quotation_id}`,
        this.message_notifier_comment
      );
      if (resp.data.status == constant.RESPONSE_STATUS_OK) {
        // update the comment object
        var db = this.$root.messageCenterApp.firestore();
        // update the comment id
        await db
          .collection(this.collectionComments)
          .doc(this.message_notifier_comment.quotation_id)
          .collection(this.collectionMessages)
          .doc(this.message_notifier_comment.comment_id)
          .update({
            admin_notified: this.message_notifier_comment.admin_notified,
            customer_notified: this.message_notifier_comment.customer_notified,
          });

        this.showSnackbar = true;
        this.snackbarColor = "success";
        this.snackbarMsg = resp.data.msg;

        setTimeout(() => {
          this.$root.blockUIshow = false;
          this.onDialogClose();
        }, 3000);
      } else {
        this.showSnackbar = true;
        this.snackbarColor = "error";
        this.snackbarMsg = resp.data.msg;
      }

      this.$root.blockUIshow = false;
    },

    /**
     * Close dialog
     */
    onDialogClose() {
      this.$emit("dialog-close");
    },
  },
};
</script>

<style scoped></style>
